export default "//cloud.imgsmail.ru/cloud.mail.ru/148635/img/build/empty-state/gallery_all.png";